export const calculateSwimTimeForPace = ({
    paceInSeconds,
    distanceInMeters
}) => (paceInSeconds / 100) * distanceInMeters;
